/** Query-string key for the current page. Shared by every paginated view. */
export const PAGE_PARAM = "p" as const;

/** Query-string key for the active tab. Shared by every tabbed view. */
export const TAB_PARAM = "tab" as const;

/**
 * Narrows a raw query-string value to one of `values`. Falls back to `fallback` when the value is
 * missing or not one of them.
 */
export function parseEnumParam<T extends string>(
  values: readonly T[],
  raw: string | null,
  fallback: T,
): T {
  return values.find((value) => value === raw) ?? fallback;
}

/** Narrows a raw query-string value to a 1-based page number. Falls back to the first page. */
export function parsePageParam(raw: string | null): number {
  const page = Number(raw);

  return Number.isInteger(page) && page >= 1 ? page : 1;
}

export function updateSearchParams(
  searchParams: URLSearchParams,
  newParams: Record<string, string | string[]>,
) {
  Object.entries(newParams).forEach(([key, value]) => {
    if (Array.isArray(value)) {
      searchParams.delete(key);
      value.forEach((v) => searchParams.append(key, v));
    } else {
      searchParams.set(key, value);
    }
  });
  return searchParams;
}
